<template>
  <v-row no-gutters>
    <v-col cols="12" md="4" class="py-0">
      <b>{{
        $t("horses:horseApplicationPonyMeasurement.applicantSection.title")
      }}</b>
      <br />
      <div class="mb-2 mt-2">
        <b>{{
          $t("horses:horseApplication.applicantFirstName.label", "First name")
        }}</b
        >&nbsp;
        <template v-if="item.applicantFirstName">
          {{ item.applicantFirstName }}
        </template>
        <template
          v-else-if="item.applicantPerson && item.applicantPerson.firstName"
        >
          {{ item.applicantPerson.firstName }}
        </template>
      </div>
      <div class="mb-2">
        <b> {{ $t("horses:horseApplication.applicantLastName.label") }}</b
        >&nbsp;
        <template v-if="item.applicantLastName">
          {{ item.applicantLastName }}
        </template>
        <template
          v-else-if="item.applicantPerson && item.applicantPerson.lastName"
        >
          {{ item.applicantPerson.lastName }}
        </template>
      </div>
      <div class="mb-2">
        <b>{{ $t("horses:horseApplication.applicantEmail.label") }}</b
        >&nbsp;
        <template v-if="item.applicantEmail">
          {{ item.applicantEmail }}
        </template>
        <template
          v-else-if="item.applicantPerson && item.applicantPerson.email"
        >
          {{ item.applicantPerson.email }}
        </template>
      </div>
      <div class="mb-2">
        <b>{{ $t("horses:horseApplication.applicantPhone.label") }}</b
        >&nbsp;
        <template v-if="item.applicantPhone">
          {{ item.applicantPhone }}
        </template>
        <template
          v-else-if="item.applicantPerson && item.applicantPerson.phone"
        >
          {{ item.applicantPerson.phone }}
        </template>
      </div>
      <br />
      <b>{{ $t("horses:horseApplication.applicantComment.label") }}</b
      >&nbsp;
      <div>
        {{ item.applicantComment }}
      </div>

      <br />
      <b class="mb-2">
        {{ $t("horses:horseApplication.commentToApplicant.label") }} </b
      >&nbsp;
      <div>{{ item.conclusionComment }}</div>

      <template v-if="item.internalComment">
        <br />
        <b class="mb-2">
          {{ $t("horses:horseApplication.internalComment.label") }} </b
        >&nbsp;
        <div>{{ item.internalComment }}</div>
        <br />
      </template>

      <template v-if="item.paymentStatus == 'REFUNDED'">
        <br />
        <b class="mb-2">
          {{
            $t(
              "common:payments.refund.comment.label",
              "Comment or reason for refund:"
            )
          }} </b
        >&nbsp;
        <div>{{ item.payable.refundComment }}</div>
        <br />
        <b class="mb-2">
          {{
            $t(
              "common:payments.refund.refundInitiatedAt.label",
              "Refund initiated at:"
            )
          }} </b
        >&nbsp;
        <div>
          {{ $dayjs.date(item.payable.refundedAt, "fullTime") }}
        </div>
        <br />
        <b class="mb-2">
          {{
            $t(
              "common:payments.refund.refundInitiatedby.label",
              "Refund initiated by:"
            )
          }} </b
        >&nbsp;
        <div>
          <AppShowPersonName :person="item.payable.refundedByPerson" />
        </div>

        <br />
      </template>
    </v-col>
    <v-col cols="12" md="4" class="py-0">
      <b>{{ $t("horses:horseApplication.ponyMeasurementSection.title") }}</b>
      <br />
      <div class="mb-2 mt-2">
        <b>{{ $t("horses:horseApplication.ponyMeasurementDate.label") }}</b
        >&nbsp;

        {{ $dayjs.date(item.ponyMeasurementDate) }}
      </div>
      <div class="mb-2">
        <b>{{ $t("horses:horseApplication.ponyMeasurementHeight.label") }}</b
        >&nbsp;

        {{ item.ponyMeasurementHeight }}cm
        {{
          item.ponyMeasurementWithHorseshoe
            ? `(${$t(
                "horses:horseApplication.ponyMeasurementWithHorseshoe.label"
              )})`
            : `(${$t(
                "horses:horseApplication.ponyMeasurementWithOutHorseshoe.label"
              )})`
        }}
      </div>

      <div v-if="item.ponyMeasurementMeasurerPerson" class="mb-2">
        <b>{{
          $t(
            "horses:horseApplication.ponyMeasurementVeterinarianSelection.label",
            "Select pony measurement specialist"
          )
        }}</b
        >&nbsp;
        <AppShowPersonName :person="item.ponyMeasurementMeasurerPerson" />
      </div>

      <div class="mb-2">
        <b>{{
          $t("horses:horseApplication.ponyMeasurementVeterinarianName.label")
        }}</b
        >&nbsp;

        {{ item.ponyMeasurementVeterinarianName }}
      </div>
    </v-col>
  </v-row>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";
import AppShowPersonName from "@AppShows/person/AppShowPersonName.vue";

export default defineComponent({
  name: "PonyMeasurementDetails",
  components: { AppShowPersonName },
  props: { item: { type: Object, required: true } },
  fragments: {
    details: gql`
      fragment _ on HorseApplication {
        applicantFirstName
        applicantLastName
        applicantEmail
        applicantPhone
        applicantPerson {
          id
          firstName
          lastName
          dateOfBirth
          email
          phone
          countryId
          country @client {
            id
            name
            ioc
            alpha2
          }
          addressCity
          addressText
          addressIndex
        }
        documents {
          id
          filename
          path
        }
        ponyMeasurementDate
        ponyMeasurementHeight
        ponyMeasurementVeterinarianName
        ponyMeasurementWithHorseshoe
        ponyMeasurementMeasurerPersonId
        ponyMeasurementMeasurerPerson {
          id
          ${AppShowPersonName.fragments.person}
        }

        applicantComment
        conclusionComment
        internalComment
        paymentStatus
        payable {
          id
          refundComment
          refundedAt
          refundedByPerson {
            id
            ${AppShowPersonName.fragments.person}
          }
        }
      }
    `
  }
});
</script>
